<div class="dynamic-report-grid" *ngIf="visibleReports.length">
    <div *ngFor="let report of visibleReports; trackBy: trackReportByCode"
        #reportGridItem
        class="dynamic-report-grid-item"
        [attr.data-report-code]="report.code"
        [class.dynamic-report-grid-item--expanded]="expandedByCode[report.code]"
        [ngClass]="getReportGridClass(report)">

        <mat-accordion class="mat-elevation-z4">
            <mat-expansion-panel
                class="dynamic-report-panel"
                [class.dynamic-report-panel--loading]="isReportLoading(report)"
                [disabled]="isReportDisabled(report)"
                [expanded]="expandedByCode[report.code]"
                (opened)="expandedByCode[report.code] = true"
                (closed)="expandedByCode[report.code] = false">

                <mat-expansion-panel-header class="dynamic-report-footer">
                    <mat-panel-title>
                        <b>{{ report.name }}</b>
                    </mat-panel-title>

                    <mat-panel-description>
                        <select *ngIf="hasCompatibleChartTypeOptions(report)"
                            #chartTypeSelect
                            class="dynamic-report-chart-type"
                            [value]="getSelectedChartType(report)"
                            [disabled]="isReportLoading(report)"
                            (click)="$event.stopPropagation()"
                            (mousedown)="$event.stopPropagation()"
                            (change)="onReportChartTypeChange(report, chartTypeSelect.value)">

                            <option *ngFor="let option of getCompatibleChartTypes(report)"
                                [value]="option.chartType"
                                [selected]="option.chartType === getSelectedChartType(report)">
                                {{ option.label }}
                            </option>
                        </select>

                        <button *ngIf="shouldShowReportFilterToggle(report)"
                            mat-stroked-button
                            type="button"
                            class="dynamic-report-header-action"
                            (click)="$event.stopPropagation(); toggleReportFilters(report)">
                            <mat-icon>{{ areReportFiltersVisible(report) ? 'filter_alt_off' : 'filter_alt' }}</mat-icon>
                            {{ areReportFiltersVisible(report) ? 'Ocultar filtros' : 'Filtros' }}
                        </button>

                        <button *ngIf="report.data && !isTable(report)"
                            mat-stroked-button
                            type="button"
                            class="dynamic-report-header-action"
                            (click)="$event.stopPropagation(); toggleReportView(report)">
                            <mat-icon>{{ isListView(report) ? 'insert_chart' : 'view_list' }}</mat-icon>
                            {{ isListView(report) ? 'Ver gráfico' : 'Ver lista' }}
                        </button>
                    </mat-panel-description>
                </mat-expansion-panel-header>

                <div *ngIf="isReportLoading(report)"
                    class="dynamic-report-loading-overlay">
                    <mat-progress-spinner mode="indeterminate" diameter="34" strokeWidth="4">
                    </mat-progress-spinner>
                    <span>Atualizando dashboard</span>
                </div>

                <ng-container *ngIf="getAppliedFilterBadges(report) as appliedFilterBadges">
                    <div *ngIf="appliedFilterBadges.length"
                        class="dynamic-report-filter-summary">
                        <span class="dynamic-report-filter-summary__label">Filtros</span>

                        <span *ngFor="let badge of appliedFilterBadges"
                            class="dynamic-report-filter-chip"
                            [title]="badge.label + ': ' + badge.value">
                            <b>{{ badge.label }}:</b> {{ badge.value }}
                        </span>
                    </div>
                </ng-container>

                <div *ngIf="!report.data && !isReportLoaded(report)" class="dynamic-report-empty">
                    Aguardando carregamento do dashboard.
                </div>

                <div *ngIf="!report.data && isReportLoaded(report)" class="dynamic-report-empty">
                    Relatório sem dados disponíveis.
                </div>

                <div class="dynamic-report-body">
                    <div *ngIf="areReportFiltersVisible(report)"
                        class="panel-filters"
                        fxLayout="column"
                        fxLayoutGap="8px">

                        <div fxLayout="row wrap"
                            fxLayout.lt-lg="column"
                            fxLayoutGap="16px">

                            <mat-form-field *ngIf="shouldShowReportPeriodFilter(report)"
                                appearance="outline"
                                fxFlex="25"
                                fxFlex.lt-lg="100">

                                <mat-label>Período deste dashboard</mat-label>

                                <mat-date-range-input [rangePicker]="reportPeriodPicker">
                                    <input #reportStartInput
                                        matStartDate
                                        placeholder="Data inicial"
                                        [value]="getReportPeriodStart(report)"
                                        (input)="onReportPeriodChange(report, 'startDate', null, $any($event.target).value)"
                                        (dateInput)="onReportPeriodChange(report, 'startDate', $event.value)">

                                    <input #reportEndInput
                                        matEndDate
                                        placeholder="Data final"
                                        [value]="getReportPeriodEnd(report)"
                                        (input)="onReportPeriodChange(report, 'endDate', null, $any($event.target).value)"
                                        (dateInput)="onReportPeriodChange(report, 'endDate', $event.value)">
                                </mat-date-range-input>

                                <button mat-icon-button
                                    matSuffix
                                    type="button"
                                    (click)="clearReportPeriod(report, reportStartInput, reportEndInput)">
                                    <mat-icon>close</mat-icon>
                                </button>

                                <mat-datepicker-toggle matSuffix [for]="reportPeriodPicker"></mat-datepicker-toggle>
                                <mat-date-range-picker #reportPeriodPicker></mat-date-range-picker>
                            </mat-form-field>

                            <mat-form-field *ngIf="shouldShowReportSingleDateFilter(report)"
                                appearance="outline"
                                fxFlex="25"
                                fxFlex.lt-lg="100">

                                <mat-label>Data deste dashboard</mat-label>

                                <input #reportSingleDateInput
                                    matInput
                                    [matDatepicker]="reportSingleDatePicker"
                                    placeholder="Data"
                                    [value]="getReportSingleDate(report)"
                                    (input)="onReportSingleDateChange(report, null, $any($event.target).value)"
                                    (dateInput)="onReportSingleDateChange(report, $event.value)">

                                <button mat-icon-button
                                    matSuffix
                                    type="button"
                                    (click)="clearReportPeriod(report, reportSingleDateInput, reportSingleDateInput)">
                                    <mat-icon>close</mat-icon>
                                </button>

                                <mat-datepicker-toggle matSuffix [for]="reportSingleDatePicker"></mat-datepicker-toggle>
                                <mat-datepicker #reportSingleDatePicker></mat-datepicker>
                            </mat-form-field>

                            <ng-container *ngFor="let filter of getReportFilters(report)">
                                <mat-form-field *ngIf="filter.type === 'MULTI_SELECT'"
                                    appearance="outline"
                                    fxFlex="25"
                                    fxFlex.lt-lg="100">

                                    <mat-label>{{ filter.label }}</mat-label>

                                    <mat-select multiple
                                        [value]="getReportFilterValue(report, filter)"
                                        (selectionChange)="onReportFilterChange(report, filter, $event.value)">

                                        <mat-option *ngFor="let option of filter.options || []"
                                            [value]="option.value">
                                            {{ option.label }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field *ngIf="filter.type === 'SELECT'"
                                    appearance="outline"
                                    fxFlex="25"
                                    fxFlex.lt-lg="100">

                                    <mat-label>{{ filter.label }}</mat-label>

                                    <mat-select
                                        [value]="getReportFilterValue(report, filter)"
                                        (selectionChange)="onReportFilterChange(report, filter, $event.value)">

                                        <mat-option *ngFor="let option of filter.options || []"
                                            [value]="option.value">
                                            {{ option.label }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field *ngIf="filter.type === 'TEXT'"
                                    appearance="outline"
                                    fxFlex="25"
                                    fxFlex.lt-lg="100">

                                    <mat-label>{{ filter.label }}</mat-label>

                                    <input matInput
                                        [value]="getReportFilterValue(report, filter)"
                                        (change)="onReportFilterChange(report, filter, $any($event.target).value)">
                                </mat-form-field>

                                <mat-form-field *ngIf="filter.type === 'NUMBER'"
                                    appearance="outline"
                                    fxFlex="25"
                                    fxFlex.lt-lg="100">

                                    <mat-label>{{ filter.label }}</mat-label>

                                    <input matInput
                                        type="number"
                                        min="1"
                                        [value]="getReportFilterValue(report, filter)"
                                        (change)="onReportFilterChange(report, filter, $any($event.target).value)">
                                </mat-form-field>
                            </ng-container>
                        </div>
                    </div>

                    <div *ngIf="report.data && isListView(report)"
                        class="dynamic-report-list dynamic-report-flip">

                        <table>
                            <thead>
                                <tr>
                                    <th>Grupo</th>
                                    <th>Item</th>
                                    <th>Valor</th>
                                    <th>Detalhe</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let row of getReportListRows(report)">
                                    <td>{{ row.group || '-' }}</td>
                                    <td>{{ row.label }}</td>
                                    <td>{{ formatListValue(report, row) }}</td>
                                    <td>{{ row.detail || '-' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div *ngIf="report.data && !isListView(report) && !hasReportRows(report)"
                        class="dynamic-report-empty dynamic-report-flip">
                        Relatório sem dados disponíveis para os filtros selecionados.
                    </div>

                    <div *ngIf="report.data && !isListView(report) && isTable(report) && hasReportRows(report)"
                        class="dynamic-report-table dynamic-report-flip">

                        <table>
                            <thead>
                                <tr>
                                    <th *ngFor="let column of getTableColumns(report)"
                                        [class.dynamic-report-table__number]="column.key !== 'label'">
                                        {{ column.label }}
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let row of getTableRows(report)">
                                    <td *ngFor="let column of getTableColumns(report)"
                                        [class.dynamic-report-table__number]="column.key !== 'label'">
                                        {{ formatTableValue(report, column, row) }}
                                    </td>
                                </tr>
                            </tbody>

                            <tfoot>
                                <tr>
                                    <td *ngFor="let column of getTableColumns(report)"
                                        [class.dynamic-report-table__number]="column.key !== 'label'">
                                        {{ formatTableTotal(report, column) }}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>

                    <ng-container *ngIf="report.data && !isListView(report) && !isTable(report) && hasReportRows(report)">
                        <div *ngIf="isStatusCount(report)"
                            class="dynamic-report-flip dynamic-report-status-grid"
                            [ngStyle]="getStatusGridStyle(report)">

                        <fuse-widget *ngFor="let status of report.data"
                            class="widget status-card"
                            fxLayout="column">

                            <div class="fuse-widget-front status-card__front"
                                [ngStyle]="{ 'border-top': '6px solid ' + getStatusColor(status) }">

                                <div class="pl-8 pr-4 py-8 border-bottom status-card__header"
                                    fxLayout="row"
                                    fxLayoutAlign="space-between center">

                                    <div class="h4 status-card__title"
                                        [ngStyle]="{ color: getStatusColor(status) }">
                                        {{ status.label }}
                                    </div>

                                    <mat-icon class="status-card__icon"
                                        [ngStyle]="{ color: getStatusColor(status) }">
                                        {{ getStatusCardIcon(report) }}
                                    </mat-icon>
                                </div>

                                <div class="py-16" fxLayout="column" fxLayoutAlign="center center">
                                    <div class="font-size-36 line-height-40 status-card__value"
                                        [class.status-card__value--currency]="isCurrencyValue(report)"
                                        [ngStyle]="{ color: getStatusColor(status) }">
                                        {{ formatStatusCardValue(report, status) }}
                                    </div>

                                    <div *ngIf="status.detail"
                                        class="status-card__detail">
                                        {{ status.detail }}
                                    </div>
                                </div>
                            </div>
                        </fuse-widget>
                    </div>

                        <div *ngIf="isColumnPercentGroup(report)"
                            class="dynamic-report-flip dynamic-report-chart-grid">

                        <div *ngFor="let c of report.data; let i = index"
                            class="dynamic-report-chart-cell">

                            <mat-card class="mat-elevation-z2">
                                <mat-card-header>
                                    <mat-card-title>{{ c.title }}</mat-card-title>
                                </mat-card-header>

                                <mat-card-content>
                                    <apx-chart *ngIf="chartOptionsByCode[report.code]?.[i]"
                                        [series]="chartOptionsByCode[report.code]?.[i]?.series"
                                        [colors]="chartOptionsByCode[report.code]?.[i]?.colors"
                                        [chart]="chartOptionsByCode[report.code]?.[i]?.chart"
                                        [dataLabels]="chartOptionsByCode[report.code]?.[i]?.dataLabels"
                                        [plotOptions]="chartOptionsByCode[report.code]?.[i]?.plotOptions"
                                        [yaxis]="chartOptionsByCode[report.code]?.[i]?.yaxis"
                                        [xaxis]="chartOptionsByCode[report.code]?.[i]?.xaxis"
                                        [legend]="chartOptionsByCode[report.code]?.[i]?.legend"
                                        [tooltip]="chartOptionsByCode[report.code]?.[i]?.tooltip">
                                    </apx-chart>
                                </mat-card-content>
                            </mat-card>
                        </div>
                    </div>

                        <div *ngIf="isPolarAreaGroup(report) || isRadialBar(report)"
                            class="dynamic-report-flip dynamic-report-chart-grid">

                        <div *ngFor="let c of report.data; let i = index"
                            class="dynamic-report-chart-cell">

                            <mat-card class="mat-elevation-z2">
                                <mat-card-header>
                                    <mat-card-title>{{ c.title }}</mat-card-title>
                                </mat-card-header>

                                <mat-card-content>
                                    <apx-chart *ngIf="chartOptionsByCode[report.code]?.[i]"
                                        [series]="chartOptionsByCode[report.code]?.[i]?.series"
                                        [labels]="chartOptionsByCode[report.code]?.[i]?.labels"
                                        [colors]="chartOptionsByCode[report.code]?.[i]?.colors"
                                        [chart]="chartOptionsByCode[report.code]?.[i]?.chart"
                                        [plotOptions]="chartOptionsByCode[report.code]?.[i]?.plotOptions"
                                        [stroke]="chartOptionsByCode[report.code]?.[i]?.stroke"
                                        [fill]="chartOptionsByCode[report.code]?.[i]?.fill"
                                        [legend]="chartOptionsByCode[report.code]?.[i]?.legend"
                                        [tooltip]="chartOptionsByCode[report.code]?.[i]?.tooltip">
                                    </apx-chart>

                                    <div *ngIf="isRadialBar(report)"
                                        fxLayout="column"
                                        fxLayoutGap="6px"
                                        class="dynamic-report-meta">
                                        <div><b>Total agendamentos:</b> {{ c.totalAppointments }}</div>
                                        <div><b>Total faltas:</b> {{ c.totalAbsences }}</div>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                        </div>
                    </div>

                        <div *ngIf="isBarHorizontal(report) || isColumnValue(report) || isLine(report) || isLineMultiple(report) || isPolarArea(report)"
                            class="dynamic-report-flip"
                            fxLayout="row wrap"
                            fxLayoutGap="20px 20px">

                        <div fxFlex="100%">
                            <mat-card class="mat-elevation-z2"
                                [class.dynamic-report-column-value-card]="isColumnValue(report)">
                                <mat-card-header>
                                    <div fxLayout="column" fxLayoutGap="4px">
                                        <mat-card-title>
                                            {{ report.data?.title || report.name }}
                                        </mat-card-title>

                                        <ng-container *ngIf="getChartSubtitleLines(report) as chartSubtitleLines">
                                            <mat-card-subtitle *ngIf="chartSubtitleLines.length">
                                                <div *ngFor="let subtitleLine of chartSubtitleLines">
                                                    {{ subtitleLine }}
                                                </div>
                                            </mat-card-subtitle>
                                        </ng-container>
                                    </div>
                                </mat-card-header>

                                <mat-card-content>
                                    <apx-chart *ngIf="isBarHorizontal(report) && chartOptionsByCode[report.code]"
                                        [series]="chartOptionsByCode[report.code]?.series"
                                        [colors]="chartOptionsByCode[report.code]?.colors"
                                        [chart]="chartOptionsByCode[report.code]?.chart"
                                        [plotOptions]="chartOptionsByCode[report.code]?.plotOptions"
                                        [dataLabels]="chartOptionsByCode[report.code]?.dataLabels"
                                        [xaxis]="chartOptionsByCode[report.code]?.xaxis"
                                        [tooltip]="chartOptionsByCode[report.code]?.tooltip">
                                    </apx-chart>

                                    <apx-chart *ngIf="isColumnValue(report) && chartOptionsByCode[report.code]"
                                        [series]="chartOptionsByCode[report.code]?.series"
                                        [colors]="chartOptionsByCode[report.code]?.colors"
                                        [chart]="chartOptionsByCode[report.code]?.chart"
                                        [grid]="chartOptionsByCode[report.code]?.grid"
                                        [plotOptions]="chartOptionsByCode[report.code]?.plotOptions"
                                        [dataLabels]="chartOptionsByCode[report.code]?.dataLabels"
                                        [yaxis]="chartOptionsByCode[report.code]?.yaxis"
                                        [xaxis]="chartOptionsByCode[report.code]?.xaxis"
                                        [legend]="chartOptionsByCode[report.code]?.legend"
                                        [tooltip]="chartOptionsByCode[report.code]?.tooltip">
                                    </apx-chart>

                                    <apx-chart *ngIf="(isLine(report) || isLineMultiple(report)) && chartOptionsByCode[report.code]"
                                        [series]="chartOptionsByCode[report.code]?.series"
                                        [colors]="chartOptionsByCode[report.code]?.colors"
                                        [chart]="chartOptionsByCode[report.code]?.chart"
                                        [plotOptions]="chartOptionsByCode[report.code]?.plotOptions"
                                        [dataLabels]="chartOptionsByCode[report.code]?.dataLabels"
                                        [markers]="chartOptionsByCode[report.code]?.markers"
                                        [fill]="chartOptionsByCode[report.code]?.fill"
                                        [stroke]="chartOptionsByCode[report.code]?.stroke"
                                        [yaxis]="chartOptionsByCode[report.code]?.yaxis"
                                        [xaxis]="chartOptionsByCode[report.code]?.xaxis"
                                        [tooltip]="chartOptionsByCode[report.code]?.tooltip"
                                        [legend]="chartOptionsByCode[report.code]?.legend">
                                    </apx-chart>

                                    <apx-chart *ngIf="isPolarArea(report) && chartOptionsByCode[report.code]"
                                        [series]="chartOptionsByCode[report.code]?.series"
                                        [labels]="chartOptionsByCode[report.code]?.labels"
                                        [colors]="chartOptionsByCode[report.code]?.colors"
                                        [chart]="chartOptionsByCode[report.code]?.chart"
                                        [stroke]="chartOptionsByCode[report.code]?.stroke"
                                        [dataLabels]="chartOptionsByCode[report.code]?.dataLabels"
                                        [legend]="chartOptionsByCode[report.code]?.legend"
                                        [tooltip]="chartOptionsByCode[report.code]?.tooltip">
                                    </apx-chart>
                                </mat-card-content>
                            </mat-card>
                        </div>
                        </div>
                    </ng-container>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>
